import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { LabelService } from 'src/app/_services/label.service';

@Component({
  selector: 'app-mobil-duzenle',
  templateUrl: './mobil-duzenle.component.html',
  styleUrls: ['./mobil-duzenle.component.css']
})
export class MobilDuzenleComponent implements OnInit {


  constructor( 
    private labelService:LabelService,
    private formBuilder:FormBuilder,
    private activeModal:NgbActiveModal,
    private toastr: ToastrService
  ) { }
  submitted=false;
  @Input() label:any;
  definitionForm:FormGroup;
  ngOnInit() {

    this.definitionForm = this.formBuilder.group({
      drugName: [this.label.patientMobileAppDrugInformation.drugName],
      indications:[this.label.patientMobileAppDrugInformation.indications],
      administrationMethodNote:[this.label.patientMobileAppDrugInformation.administrationMethodNote],
activeIngredients:this.formBuilder.array([]),
warnings:this.formBuilder.array([]),
dosageInstructions:this.formBuilder.group({
  adults:[this.label.patientMobileAppDrugInformation.dosageInstructions.adults],
  maximumDailyDose:[this.label.patientMobileAppDrugInformation.dosageInstructions.maximumDailyDose]
})
    });


 this.label.patientMobileAppDrugInformation.warnings.forEach(element => {
        this.addWarning(element);
    });

     this.label.patientMobileAppDrugInformation.activeIngredients.forEach(element => {
        this.addIngredients(element);
    });
    
  }
  close(){
    this.activeModal.close();
  }


  save(){
        var model=this.definitionForm.value;
    model.warnings=model.warnings.map(x=>x.property);




     this.labelService.updateMobil(model,this.label.id,false).subscribe(res=>{
  this.toastr.success('','Mobil Etiket güncellendi!');
          this.activeModal.close();
     },err=>{
        this.toastr.error('','Mobil Etiket güncelleme sırasında hata oluştu!');
      });
  }

 saveall(){
   var model=this.definitionForm.value;
    model.warnings=model.warnings.map(x=>x.property);




     this.labelService.updateMobil(model,this.label.id,true).subscribe(res=>{
        this.toastr.success('','Mobil Etiket güncellendi!');
          this.activeModal.close();
     },err=>{
        this.toastr.error('','Mobil Etiket güncelleme sırasında hata oluştu!');
      });
  }



     getWarning() {
      return this.definitionForm.get("warnings") as FormArray;
    }
  
    addWarning(name:any) {
      this.getWarning().push(this.createWarning(name));
    }
  
    createWarning(name:any): FormGroup {
      return this.formBuilder.group({
        property: [name]
       
      });
    }
    
    removeWarning(i) {
      this.getWarning().removeAt(i);
    }
  


    

     getIngredients() {
      return this.definitionForm.get("activeIngredients") as FormArray;
    }
  
    addIngredients(name:any) {
      this.getIngredients().push(this.createIngredients(name));
    }
  
    createIngredients(name:any): FormGroup {
      return this.formBuilder.group({
        name: [name.name],
        amount:[name.amount]
       
      });
    }
    
    removeIngredients(i) {
      this.getIngredients().removeAt(i);
    }
  

    
}
